export default __webpack_public_path__ + "static/media/search-icon.0d52c4cf.svg";